
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';
import { Induction } from '../model/induction.model';

@Injectable()
export class InductionService {
  @LocalStorage() url: Url;
  private headers = new Headers({ 'Content-Type': 'application/json' });

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
    constructor(public http:HttpClient) { 
    }

    getInductions(id:number): Observable<Induction[]> { 
		return this.http.get<Induction[]>(this.url.rest  + '/tms/getInductionRecordsByUserId/' + id,  this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }
  
    
    resetInductionRecord(id: number): Observable<any[]> {
      return this.http.put<any[]>(this.url.rest  + '/tms/resetInductionRecord/'+ id , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    retrainInductionRecord(induction_record): Observable<any[]> {
      return this.http.post<any[]>(this.url.rest  + '/tms/retrainInductionRecord', induction_record , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
    }

    getCertificateFiles(user_id): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest  + '/tms/getCertificateFiles/'+ user_id ,  this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }

    getInductionProgress(user_id): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest  + '/tms/getInductionProgress/'+ user_id ,  this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }

    getInductionTasks(user_id): Observable<any[]> {
      return this.http.get<any[]>(this.url.rest  + '/tms/getInductionTasks/'+ user_id ,  this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
      }

    getCompletedInductionTasks(user_id): Observable<any[]> {
    return this.http.get<any[]>(this.url.rest  + '/tms/getCompletedInductionTasks/'+ user_id ,  this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }

    getInductionSetTasksNeeded(user_id): Observable<Induction[]> {
      return this.http.get<Induction[]>(this.url.rest  + '/tms/getInductionSetTasksNeeded/'+ user_id ,  this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        )
      }

    deleteInductionRecord(induction) {
      return this.http.post(this.url.rest  + '/tms/deleteInductionRecord', induction ,  this.httpOptions);
    }

    
    bulkMarkForRetrain(inductions, user_id): Observable<any[]> {
      return this.http.post<any[]>(this.url.rest  + '/tms/bulkMarkForRetrain/' + user_id, inductions,  this.httpOptions)
          .pipe(
          retry(1),
          catchError(this.handleError)
      )    
    }

    reinductionByUserId(reinduction_data): Observable<any[]> {
      return this.http.post<any[]>(this.url.rest  + '/tms/reinductionByUserId', reinduction_data,  this.httpOptions)
          .pipe(
          retry(1),
          catchError(this.handleError)
      )    
    }
  
    private extractData(res: Response) {
    	let body = res.json();
    	console.log(body);
	    if(body)
            return body || {};
        else
            return null;
    }


  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}